import {
    useEffect
} from "react";
import {
    Image
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    PageContainer
} from "ncore-ui-kit";
import {
    useGlobalState
} from "../../../context";

import OneSignalService from "../../../services/OneSignalService";
import GMKonyaLogo from "../../../assets/images/gmkonyalogo.png";
import GMKonyaLogoDark from "../../../assets/images/gmkonyalogodark.png";
import {
    RESTService
} from "../../../services/restAPI";
import {
    storage
} from "../../../storage";

const AutoLogin = () => {
    const [
        globalState,
        setGlobalState
    ] = useGlobalState();

    const {
        activeTheme
    } = NCoreUIKitTheme.useContext();

    useEffect(() => {
        const refreshToken = storage.getString("refreshToken");

        if(refreshToken) {
            RESTService.action("Me", null)
                .then((res) => {
                    const userInfo = res.payload;
                    setGlobalState({
                        ...globalState,
                        isAppReady: true,
                        isGuest: false,
                        user: {
                            profilePhotoURL: userInfo.profilePhoto,
                            companyTitle: userInfo.companyTitle,
                            companyName: userInfo.companyName,
                            phoneNumber: userInfo.phoneNumber,
                            firstName: userInfo.firstName,
                            lastName: userInfo.lastName,
                            fullName: userInfo.fullName,
                            userType: userInfo.userType,
                            company: userInfo.company,
                            userID: userInfo.userID,
                            mail: userInfo.mail
                        }
                    });

                    try {
                        OneSignalService.login(res.payload.userID);
                        OneSignalService.setTags({
                            userID: res.payload.userID
                        });
                    } catch(error) {
                        console.warn("[AutoLogin] OneSignal login error:", error);
                    }
                })
                .catch(() => {
                    try {
                        OneSignalService.logout();
                    } catch(error) {
                        console.warn("[AutoLogin] OneSignal logout error:", error);
                    }
                    storage.clearAll();
                    setGlobalState({
                        ...globalState,
                        isAppReady: true,
                        isGuest: true,
                        user: null
                    });
                });
        } else {
            try {
                OneSignalService.logout();
            } catch(error) {
                console.warn("[AutoLogin] OneSignal logout error:", error);
            }
            setGlobalState({
                ...globalState,
                isAppReady: true,
                isGuest: true,
                user: null
            });
        }
    }, []);

    return <PageContainer
        style={[
            stylesheet.container
        ]}
    >
        <Image
            resizeMode="contain"
            source={activeTheme === "dark" ? GMKonyaLogoDark : GMKonyaLogo}
            width={175}
            style={[
                stylesheet.logo
            ]}
        />
    </PageContainer>;
};
export default AutoLogin;
